<template>
	<div>		<el-card class="box-card">
			<div style="margin-bottom: 20px;">
				<el-form ref="distributorPageInfoReq" :model="distributorPageInfoReq" label-width="70px" inline size="small">
					<el-form-item label="运营商:">
						<el-input :clearable=true v-model="distributorPageInfoReq.name" placeholder="请输运营商名称" style="width: 180px;" />
					</el-form-item>
					<el-form-item>
					<el-button type="primary" @click="initDistributor()">+ 添加运营商信息</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="reGetdistributorList()">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="success" icon="el-icon-plus" @click="showSubMerchantQrCode">子商户入驻</el-button>
				</el-form-item>
				</el-form>
			</div>
			<el-table :data="distributorList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column label="运营商名称" prop="name"></el-table-column>
				<el-table-column label="登录账号" prop="loginName"></el-table-column>
				<el-table-column label="负责人" prop="chargePerson"></el-table-column>
				<el-table-column label="电话" prop="telephone1"></el-table-column>
				<el-table-column label="地址" prop="address"></el-table-column>
				<el-table-column label="邮箱" prop="email"></el-table-column>
				<el-table-column label="注册时间" prop="registerTime" width="180"></el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="350" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-edit"
							@click="updateDistributorInit(scope.row.id)">编辑</el-button>
						<el-button size="mini" type="primary" icon="el-icon-setting"
							@click="distributorSettingInit(scope.row.id)">配置</el-button>
						<el-button size="mini" type="warning" icon="el-icon-share"
							@click="showSetParentDialog(scope.row)">设置上级</el-button>
						<el-button size="mini" type="primary" icon="el-icon-s-grid"
							@click="showQrCode(scope.row)">运维码</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="distributorPageInfoReq.page" :page-sizes="[8, 15, 25, 50, 100]"
				:page-size="distributorPageInfoReq.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>

			<el-dialog title="修改运营商信息" :visible.sync="updateDistributorDialogVisible" width="800px">
				<el-form :model="distributorInfo" status-icon :rules="addDistributorRules" ref="distributorInfoUpdate"
					label-width="100px" class="demo-ruleForm" style="padding-right: 50px;">
					<el-col :span="12">
						<el-form-item label="运营商名称:" prop="name">
							<el-input v-model.trim="distributorInfo.name" size="small"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="地址:" prop="address">
							<el-input v-model.trim="distributorInfo.address" type="text" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="登录账号:" prop="loginName">
							<el-input v-model.trim="distributorInfo.loginName" type="text" size="small"
								:disabled="true"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="负责人姓名:" prop="chargePerson">
							<el-input v-model.trim="distributorInfo.chargePerson" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号:" prop="telephone1">
							<el-input v-model.trim="distributorInfo.telephone1" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="email:" prop="email">
							<el-input v-model.trim="distributorInfo.email" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateDistributorDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="updateDistributor()">确 定</el-button>
				</span>
			</el-dialog>

			<el-dialog title="添加运营商信息" :visible.sync="addDistributorDialogVisible" width="800px">
				<el-form :model="distributorInfo" status-icon :rules="addDistributorRules" ref="distributorInfoUpdate"
					label-width="100px" class="demo-ruleForm" style="padding-right: 50px;">
					<el-col :span="12">
						<el-form-item label="运营商名称:" prop="name">
							<el-input v-model.trim="distributorInfo.name" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="地址:" prop="address">
							<el-input v-model.trim="distributorInfo.address" type="text" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="登录账号:" prop="loginName">
							<el-input v-model.trim="distributorInfo.loginName" type="text" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="负责人姓名:" prop="chargePerson">
							<el-input v-model.trim="distributorInfo.chargePerson" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号:" prop="telephone1">
							<el-input v-model.trim="distributorInfo.telephone1" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="email:" prop="email">
							<el-input v-model.trim="distributorInfo.email" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addDistributorDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="addDistributor()">确 定</el-button>
				</span>
			</el-dialog>

			<el-dialog title="设置运营商配置" :visible.sync="distributorSettingInitDialogVisible" width="1200px">
				<el-card shadow="never" style="margin-bottom: 15px; border: 1px dashed #dcdfe6;">
					<div slot="header" style="display: flex; align-items: center; justify-content: space-between; padding: 0;">
						<span style="font-size: 14px; font-weight: bold; color: #303133;">开启车辆类型</span>
						<el-button size="mini" type="primary" icon="el-icon-check" @click="saveEnabledDeviceTypes" :loading="saveDeviceTypeLoading">保存</el-button>
					</div>
					<el-checkbox-group v-model="enabledDeviceTypeCodes" v-loading="configLoading">
						<el-checkbox v-for="item in allDeviceTypeConfigList" :key="item.deviceTypeCode" :label="item.deviceTypeCode" style="margin-right: 20px; margin-bottom: 8px;">
							<el-tag v-if="item.bicycleType === 1" type="success" size="mini" style="margin-right: 4px;">自行车锁</el-tag>
							<el-tag v-else-if="item.bicycleType === 2" type="primary" size="mini" style="margin-right: 4px;">电动车锁</el-tag>
							<el-tag v-else-if="item.bicycleType === 3" type="warning" size="mini" style="margin-right: 4px;">涨闸锁</el-tag>
							{{ item.deviceTypeName }}
						</el-checkbox>
					</el-checkbox-group>
				</el-card>
				<el-table :data="deviceTypeConfigList" border stripe :header-cell-style="{ textAlign: 'center' }"
					:cell-style="{ textAlign: 'center' }" v-loading="configLoading">
					<el-table-column type="index" width="60"></el-table-column>
					<el-table-column label="车锁类型" width="100">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.bicycleType === 1" type="success" size="small">自行车锁</el-tag>
							<el-tag v-else-if="scope.row.bicycleType === 2" type="primary" size="small">电动车锁</el-tag>
							<el-tag v-else-if="scope.row.bicycleType === 3" type="warning" size="small">涨闸锁</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="车辆类型" prop="deviceTypeName"></el-table-column>
					<el-table-column label="第1阶段(分钟)" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage1Minute ?? '-' }}
						</template>
					</el-table-column>
					<el-table-column label="第1阶段收费" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage1Fee ?? '-' }}元
						</template>
					</el-table-column>
					<el-table-column label="第2阶段(分钟)" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage2Minute ?? '-' }}
						</template>
					</el-table-column>
					<el-table-column label="第2阶段收费" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage2Fee ?? '-' }}元
						</template>
					</el-table-column>
					<el-table-column label="第3阶段(分钟)" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage3Minute ?? '-' }}
						</template>
					</el-table-column>
					<el-table-column label="第3阶段收费" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage3Fee ?? '-' }}元
						</template>
					</el-table-column>
					<el-table-column label="押金" width="80">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).precharge || '-' }}
						</template>
					</el-table-column>
					<el-table-column label="限额" width="80">
						<template slot-scope="scope">
							<template v-if="getSettingConfig(scope.row.deviceTypeCode).enableLimit === 1">
								{{ getSettingConfig(scope.row.deviceTypeCode).limitAmount || '-' }}
							</template>
							<template v-else>-</template>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="120" fixed="right">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" icon="el-icon-edit"
							@click="editDeviceTypeConfig(scope.row)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<span slot="footer" class="dialog-footer">
					<el-button @click="distributorSettingInitDialogVisible = false">关 闭</el-button>
				</span>
			</el-dialog>

			<el-dialog :title="configDialogTitle" :visible.sync="configDialogVisible" width="900px" append-to-body>
				<el-form :model="configForm" :rules="configRules" ref="configFormRef" label-width="120px" style="padding-right: 50px;">
					<el-row>
						<el-col :span="24">
							<el-divider content-position="left">
								<el-tag v-if="configForm.bicycleType === 1" type="success" size="small">自行车锁</el-tag>
								<el-tag v-else-if="configForm.bicycleType === 2" type="primary" size="small">电动车锁</el-tag>
								<el-tag v-else-if="configForm.bicycleType === 3" type="warning" size="small">涨闸锁</el-tag>
								- {{ configForm.deviceTypeName }}
							</el-divider>
						</el-col>
					</el-row>
					<el-divider content-position="left">第1阶段（起步价）</el-divider>
					<el-row>
						<el-col :span="12">
							<el-form-item label="分钟区间:" prop="stage1Minute">
								<el-input v-model.trim="configForm.stage1Minute" size="small" :clearable=true placeholder="如：15"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="区间收费:" prop="stage1Fee">
								<el-input v-model.trim="configForm.stage1Fee" size="small" :clearable=true placeholder="如：1.00"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					
					<el-divider content-position="left">第2阶段</el-divider>
					<el-row>
						<el-col :span="12">
							<el-form-item label="分钟区间:" prop="stage2Minute">
								<el-input v-model.trim="configForm.stage2Minute" size="small" :clearable=true placeholder="如：45"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="区间收费:" prop="stage2Fee">
								<el-input v-model.trim="configForm.stage2Fee" size="small" :clearable=true placeholder="如：2.00"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					
					<el-divider content-position="left">第3阶段（循环计费）<el-tooltip content="超过第2阶段后，每满足多少分钟收取对应费用" placement="top"><i class="el-icon-question"></i></el-tooltip></el-divider>
					<el-row>
						<el-col :span="12">
							<el-form-item label="分钟区间:" prop="stage3Minute">
								<el-input v-model.trim="configForm.stage3Minute" size="small" :clearable=true placeholder="如：30"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="区间收费:" prop="stage3Fee">
								<el-input v-model.trim="configForm.stage3Fee" size="small" :clearable=true placeholder="如：1.50"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					
					<el-divider content-position="left">其他设置</el-divider>
					<el-row>
						<el-col :span="12">
							<el-form-item label="扫码说明">
								<el-switch v-model="configForm.sweepCodeStatus"></el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="扫码提示语:" prop="sweepCodeTip" v-if="configForm.sweepCodeStatus">
								<el-input v-model="configForm.sweepCodeTip" size="small" :clearable=true></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="押金">
								<el-switch v-model="configForm.prechargeStatus"></el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="押金额度:" prop="precharge" v-if="configForm.prechargeStatus">
								<el-input v-model="configForm.precharge" size="small" :clearable=true></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="限额">
								<el-switch v-model="configForm.enableLimit"></el-switch>
								<el-tooltip content="开启后，骑行费用超出限额时按限额扣费" placement="top">
									<i class="el-icon-question" style="margin-left: 5px;"></i>
								</el-tooltip>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="限额金额:" prop="limitAmount" v-if="configForm.enableLimit">
								<el-input v-model="configForm.limitAmount" size="small" :clearable=true placeholder="如：20.00"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="调度费">
								<el-switch v-model="configForm.allowDispatch"></el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="调度费用:" prop="dispatchingFee" v-if="configForm.allowDispatch">
								<el-input v-model="configForm.dispatchingFee" size="small" :clearable=true placeholder="如：5.00"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="围栏内还车">
								<el-switch v-model="configForm.enableFenceReturn"></el-switch>
								<el-tooltip content="开启后，用户关锁时将自动还车" placement="top">
									<i class="el-icon-question" style="margin-left: 5px;"></i>
								</el-tooltip>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="超出区域报警">
								<el-switch v-model="configForm.enableOutAreaAlarm"></el-switch>
								<el-tooltip content="开启后，车辆超出运营区域时将通知管理员" placement="top">
									<i class="el-icon-question" style="margin-left: 5px;"></i>
								</el-tooltip>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="蓝牙开锁">
								<el-switch v-model="configForm.enableBluetoothUnlock"></el-switch>
								<el-tooltip content="开启后，用户可使用蓝牙开锁；关闭则仅支持网络开锁" placement="top">
									<i class="el-icon-question" style="margin-left: 5px;"></i>
								</el-tooltip>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="运营时间:" prop="operationTime">
								<el-time-picker is-range v-model="configForm.operationTime" format="HH:mm" value-format="HH:mm" range-separator="-" start-placeholder="开始" end-placeholder="结束" size="small" style="width: 100%;"></el-time-picker>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="configDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="saveDeviceTypeConfig">确 定</el-button>
				</span>
			</el-dialog>
			
			<!-- 运维小程序码弹窗 -->
			<el-dialog title="运维小程序码" :visible.sync="qrCodeDialogVisible" width="400px" center @close="clearQrCode">
				<div style="text-align: center;">
					<div style="margin-bottom: 15px; font-size: 16px; color: #606266;">
						运营商：{{ qrCodeDistributorName }}
					</div>
					<div style="display: flex; justify-content: center; margin-bottom: 20px;">
						<div id="qrcodeContainer" ref="qrcodeContainer"></div>
					</div>
					<div style="font-size: 12px; color: #909399;">
						请使用微信扫描二维码进入运维小程序
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="qrCodeDialogVisible = false">关 闭</el-button>
				</span>
			</el-dialog>
			
			<!-- 设置上级运营商弹窗 -->
			<el-dialog title="设置上级运营商" :visible.sync="setParentDialogVisible" width="500px">
				<el-form :model="setParentForm" label-width="100px">
					<el-form-item label="当前运营商:">
						<span style="font-weight: bold;">{{ setParentForm.currentName }}</span>
					</el-form-item>
					<el-form-item label="当前层级:">
						<el-tag v-if="setParentForm.currentLevel === 1" type="success" size="small">一级运营商</el-tag>
						<el-tag v-else-if="setParentForm.currentLevel === 2" type="warning" size="small">二级运营商</el-tag>
						<el-tag v-else-if="setParentForm.currentLevel === 3" type="info" size="small">三级运营商</el-tag>
						<el-tag v-else type="danger" size="small">未设置</el-tag>
					</el-form-item>
					<el-form-item label="上级运营商:">
						<el-cascader
							v-model="setParentForm.parentId"
							:options="distributorTreeData"
							:props="{
								checkStrictly: true,
								value: 'id',
								label: 'name',
								children: 'children',
								emitPath: false,
								clearable: true
							}"
							placeholder="选择上级运营商（不选则为一级）"
							clearable
							filterable
							style="width: 100%;">
						</el-cascader>
					</el-form-item>
					<el-alert 
						title="提示：设置为一级运营商后，该运营商将没有上级" 
						type="info" 
						:closable="false"
						v-if="!setParentForm.parentId">
					</el-alert>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="setParentDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitSetParent" :loading="setParentLoading">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 商户开户意愿确认弹窗 -->
			<el-dialog title="商户开户意愿确认" :visible.sync="applymentDialogVisible" width="600px" :close-on-click-modal="false">
				<el-steps :active="applymentStep" finish-status="success" simple style="margin-bottom: 20px;">
					<el-step title="填写基本信息"></el-step>
					<el-step title="提交申请"></el-step>
					<el-step title="扫码确认"></el-step>
				</el-steps>

				<!-- 步骤1：填写基本信息 -->
				<div v-if="applymentStep === 0">
					<el-form :model="applymentForm" :rules="applymentRules" ref="applymentFormRef" label-width="120px" size="small">
						<el-divider content-position="left">超级管理员信息</el-divider>
						<el-row>
							<el-col :span="12">
								<el-form-item label="管理员类型" prop="contact_type">
									<el-select v-model="applymentForm.contact_type" placeholder="请选择" style="width: 100%;">
										<el-option label="经营者/法定代表人" value="LEGAL"></el-option>
										<el-option label="经办人" value="SUPER"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="管理员姓名" prop="contact_name">
									<el-input v-model.trim="applymentForm.contact_name" placeholder="请输入管理员姓名"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="管理员手机号" prop="mobile_phone">
									<el-input v-model.trim="applymentForm.mobile_phone" placeholder="请输入手机号"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="管理员邮箱" prop="contact_email">
									<el-input v-model.trim="applymentForm.contact_email" placeholder="请输入邮箱"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-divider content-position="left">主体信息</el-divider>
						<el-row>
							<el-col :span="12">
								<el-form-item label="主体类型" prop="subject_type">
									<el-select v-model="applymentForm.subject_type" placeholder="请选择主体类型" style="width: 100%;">
										<el-option label="个体工商户" value="SUBJECT_TYPE_INDIVIDUAL"></el-option>
										<el-option label="企业" value="SUBJECT_TYPE_ENTERPRISE"></el-option>
										<el-option label="小微商户" value="SUBJECT_TYPE_MICRO"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row v-if="applymentForm.subject_type && applymentForm.subject_type !== 'SUBJECT_TYPE_MICRO'">
							<el-col :span="12">
								<el-form-item label="营业执照照片" prop="license_copy">
									<el-upload
										:action="$http.defaults.baseURL + '/sub/merchant/applyment/upload'"
										:headers="uploadHeaders"
										:data="{ fileType: 'image/jpeg' }"
										:on-success="handleLicenseUploadSuccess"
										:on-error="handleLicenseUploadError"
										:show-file-list="false"
										accept="image/*"
										>
										<el-button size="small" type="primary" v-if="!applymentForm.license_copy">点击上传</el-button>
										<el-tag v-else type="success" size="small">已上传</el-tag>
									</el-upload>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="营业执照号" prop="license_number">
									<el-input v-model.trim="applymentForm.license_number" placeholder="统一社会信用代码"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row v-if="applymentForm.subject_type && applymentForm.subject_type !== 'SUBJECT_TYPE_MICRO'">
							<el-col :span="12">
								<el-form-item label="商户名称" prop="merchant_name">
									<el-input v-model.trim="applymentForm.merchant_name" placeholder="营业执照上的商户名称"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="法人姓名" prop="legal_person">
									<el-input v-model.trim="applymentForm.legal_person" placeholder="请输入法人姓名"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-divider content-position="left">经营信息</el-divider>
						<el-row>
							<el-col :span="12">
								<el-form-item label="商户简称" prop="merchant_shortname">
									<el-input v-model.trim="applymentForm.merchant_shortname" placeholder="请输入商户简称"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="经营场景" prop="sales_scenes_type">
									<el-select v-model="applymentForm.sales_scenes_type" multiple placeholder="请选择经营场景" style="width: 100%;">
										<el-option label="小程序" value="SALES_SCENES_MINI_PROGRAM"></el-option>
										<el-option label="公众号" value="SALES_SCENES_MP"></el-option>
										<el-option label="线下门店" value="SALES_SCENES_STORE"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>

				<!-- 步骤2：提交中 -->
				<div v-if="applymentStep === 1" style="text-align: center; padding: 40px 0;">
					<el-icon class="el-icon-loading" style="font-size: 40px; color: #409EFF;"></el-icon>
					<p style="margin-top: 20px; font-size: 16px; color: #606266;">正在提交申请，请稍候...</p>
				</div>

				<!-- 步骤3：显示确认二维码 -->
				<div v-if="applymentStep === 2">
					<div style="text-align: center;">
						<el-alert 
							:title="applymentResult.message || '请商户超级管理员使用微信扫描以下二维码完成确认'" 
							:type="applymentResult.applyment_state === 'APPLYMENT_STATE_PASSED' ? 'success' : (applymentResult.applyment_state === 'APPLYMENT_STATE_REJECTED' ? 'error' : 'warning')"
							:closable="false"
							style="margin-bottom: 20px;">
						</el-alert>

						<div v-if="applymentResult.applyment_state === 'APPLYMENT_STATE_PASSED'" style="padding: 20px;">
							<p style="font-size: 18px; color: #67C23A; font-weight: bold;">开户意愿确认已完成</p>
						</div>

						<div v-else-if="applymentResult.applyment_state === 'APPLYMENT_STATE_REJECTED'" style="padding: 20px;">
							<p style="font-size: 18px; color: #F56C6C; font-weight: bold;">申请已被驳回</p>
							<p style="margin-top: 10px; color: #909399;">请根据驳回原因修改申请资料后重新提交</p>
						</div>

						<div v-else>
							<div style="margin-bottom: 15px; font-size: 16px; color: #606266;">
								商户简称：{{ applymentResult.merchant_shortname || applymentForm.merchant_shortname }}
							</div>
							<div v-if="applymentResult.qrcode_data" style="display: flex; justify-content: center; margin-bottom: 20px;">
								<img :src="'data:image/png;base64,' + applymentResult.qrcode_data" style="width: 256px; height: 256px; border: 1px solid #eee;" />
							</div>
							<div v-else style="padding: 30px 0; text-align: center;">
								<i class="el-icon-time" style="font-size: 48px; color: #E6A23C;"></i>
								<p style="margin-top: 15px; font-size: 14px; color: #909399;">审核中，确认二维码将在审核通过后生成</p>
							</div>
							<div style="font-size: 12px; color: #909399;">
								申请状态: {{ applymentResult.applyment_state_msg || '审核中' }}
							</div>
							<div v-if="applymentResult.business_code" style="font-size: 12px; color: #909399; margin-top: 5px;">
								业务编号: {{ applymentResult.business_code }}
							</div>
							<div style="margin-top: 15px;">
								<el-button type="primary" size="small" @click="refreshApplymentStatus" :loading="refreshLoading">刷新状态</el-button>
							</div>
						</div>
					</div>
				</div>

				<span slot="footer" class="dialog-footer">
					<el-button @click="closeApplymentDialog">{{ applymentStep === 2 ? '关 闭' : '取 消' }}</el-button>
					<el-button v-if="applymentStep === 0" type="primary" @click="submitApplyment" :loading="applymentSubmitting">提交申请</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			distributorPageInfoReq: {
				page: 1,
				limit: 8,
				name: ''
			},
			updateDistributorDialogVisible: false,
			addDistributorDialogVisible: false,
			distributorSettingInitDialogVisible: false,
			distributorList: [],
			distributorInfo: {},
			total: 0,
			addDistributorRules: {
				name: [{ required: true, message: '请输入运营商名称', trigger: ['blur', 'change'] }],
				loginName: [{ required: true, message: '请输入登录账号', trigger: ['blur', 'change'] }],
				chargePerson: [{ required: true, message: '请输入真实姓名', trigger: ['blur', 'change'] }],
				telephone1: [{ required: true, message: '请输入手机号', trigger: ['blur', 'change'] }]
			},
			currentDistributorId: '',
			deviceTypeConfigList: [],
			allDeviceTypeConfigList: [],
			enabledDeviceTypeCodes: [],
			saveDeviceTypeLoading: false,
			settingList: [],
			configLoading: false,
			configDialogVisible: false,
			configDialogTitle: '编辑车辆类型配置',
			chargingTypeOptions: [{ key: 3, value: '按分钟收费' }],
			configForm: {
				deviceTypeCode: '',
				deviceTypeName: '',
				bicycleType: null,
				chargingType: 3,
				stage1Minute: null,
				stage1Fee: null,
				stage2Minute: null,
				stage2Fee: null,
				stage3Minute: null,
				stage3Fee: null,
				sweepCodeStatus: false,
				sweepCodeTip: '',
				prechargeStatus: false,
				precharge: null,
				enableLimit: false,
				limitAmount: null,
				allowDispatch: false,
				dispatchingFee: null,
				operationTime: ['06:00', '23:00'],
				enableFenceReturn: false,
				enableOutAreaAlarm: false,
				enableBluetoothUnlock: false
			},
			configRules: {
				stage1Minute: [{ required: true, message: '请输入第1阶段分钟区间', trigger: 'blur' }],
				stage1Fee: [{ required: true, message: '请输入第1阶段收费金额', trigger: 'blur' }]
			},
			qrCodeDialogVisible: false,
			qrCodeDistributorId: '',
			qrCodeDistributorName: '',
			setParentDialogVisible: false,
			setParentLoading: false,
			distributorTreeData: [],
			setParentForm: {
				distributorId: '',
				currentName: '',
				currentLevel: null,
				parentId: ''
			},
			applymentDialogVisible: false,
			applymentStep: 0,
			applymentSubmitting: false,
			refreshLoading: false,
			applymentForm: {
				merchant_shortname: '',
				contact_type: 'LEGAL',
				contact_name: '',
				mobile_phone: '',
				contact_email: '',
				subject_type: '',
				license_number: '',
				merchant_name: '',
				legal_person: '',
				license_copy: '',
				sales_scenes_type: ['SALES_SCENES_MINI_PROGRAM']
			},
			applymentRules: {
				merchant_shortname: [{ required: true, message: '请输入商户简称', trigger: ['blur', 'change'] }],
				contact_type: [{ required: true, message: '请选择管理员类型', trigger: ['change'] }],
				contact_name: [{ required: true, message: '请输入管理员姓名', trigger: ['blur', 'change'] }],
				mobile_phone: [{ required: true, message: '请输入管理员手机号', trigger: ['blur', 'change'] }],
				contact_email: [{ required: true, message: '请输入管理员邮箱', trigger: ['blur', 'change'] }],
				subject_type: [{ required: true, message: '请选择主体类型', trigger: ['change'] }],
				sales_scenes_type: [{ required: true, message: '请选择经营场景类型', trigger: ['change'] }]
			},
			applymentResult: {
				applyment_state: '',
				applyment_state_msg: '',
				qrcode_data: '',
				business_code: '',
				merchant_shortname: '',
				message: ''
			},
			uploadHeaders: { 'Authorization': window.sessionStorage.getItem('token') || '' }
		}
	},
	created() {
		this.getdistributorList();
	},
	methods: {
		async getdistributorList() {
			const { data: res } = await this.$http.post('/distributor/manager/list', this.distributorPageInfoReq)
			if (res.code != 200) return this.$message.error(res.msg)
			this.distributorList = res.data.list
			this.total = res.data.total
		},
		reGetdistributorList() {
			this.distributorPageInfoReq.page = 1;
			this.getdistributorList();
		},
		handleSizeChange(pageSize) {
			this.distributorPageInfoReq.limit = pageSize;
			this.getdistributorList();
		},
		handleCurrentChange(pageNum) {
			this.distributorPageInfoReq.page = pageNum;
			this.getdistributorList();
		},
		updateDistributorInit(id) {
			this.$http.get('/distributor/manager/getDistributorInfoById/' + id).then((res) => {
				if (res.data.code != 200) return this.$message.error(res.data.msg)
				this.distributorInfo = res.data.data;
				this.updateDistributorDialogVisible = true;
			});
		},
		updateDistributor() {
			this.$refs.distributorInfoUpdate.validate((valid) => {
				if (valid) {
					this.$http.post('/distributor/manager/updateDistributorById', this.distributorInfo).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.updateDistributorDialogVisible = false;
						this.reGetdistributorList();
						this.$message.success(res.data.msg);
					})
				}
			});
		},
		initDistributor() {
			this.distributorInfo = {};
			this.addDistributorDialogVisible = true;
		},
		addDistributor() {
			this.$refs.distributorInfoUpdate.validate((valid) => {
				if (valid) {
					this.$http.post('/distributor/manager/addDistributor', this.distributorInfo).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.addDistributorDialogVisible = false;
						this.reGetdistributorList();
						this.$message.success(res.data.msg);
					})
				}
			});
		},
		async distributorSettingInit(id) {
			this.currentDistributorId = id;
			this.configLoading = true;
			this.distributorSettingInitDialogVisible = true;
			
			try {
				const [deviceTypeRes, settingRes, allDeviceTypeRes, enabledRes] = await Promise.all([
					this.$http.get('/device/typeConfig/list', { params: { distributorId: id, bicycleType: null } }),
					this.$http.get('/distributor/setting/getDistributorSettingList/' + id),
					this.$http.get('/device/typeConfig/getAllList'),
					this.$http.get('/distributor/setting/getEnabledDeviceTypes/' + id)
				]);
				
				if (deviceTypeRes.data.code === 200) {
					this.deviceTypeConfigList = deviceTypeRes.data.data || [];
				}
				if (settingRes.data.code === 200) {
					this.settingList = settingRes.data.data || [];
				}
				if (allDeviceTypeRes.data.code === 200) {
					this.allDeviceTypeConfigList = allDeviceTypeRes.data.data || [];
				}
				if (enabledRes.data.code === 200) {
					this.enabledDeviceTypeCodes = enabledRes.data.data || [];
				}
			} catch (error) {
				console.error('加载配置失败:', error);
				this.$message.error('加载配置失败');
			} finally {
				this.configLoading = false;
			}
		},
		saveEnabledDeviceTypes() {
			this.saveDeviceTypeLoading = true;
			this.$http.post('/distributor/setting/saveEnabledDeviceTypes', {
				distributorId: this.currentDistributorId,
				deviceTypeCodes: this.enabledDeviceTypeCodes
			}).then((res) => {
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				this.$message.success('保存成功');
				this.distributorSettingInit(this.currentDistributorId);
			}).catch(() => {
				this.$message.error('保存失败');
			}).finally(() => {
				this.saveDeviceTypeLoading = false;
			});
		},
		getSettingConfig(deviceTypeCode) {
			const setting = this.settingList.find(s => s.deviceTypeCode === deviceTypeCode);
			return setting || {};
		},
		editDeviceTypeConfig(row) {
			const existingSetting = this.settingList.find(s => s.deviceTypeCode === row.deviceTypeCode) || {};
			this.configForm = {
				deviceTypeCode: row.deviceTypeCode,
				deviceTypeName: row.deviceTypeName,
				bicycleType: row.bicycleType,
				chargingType: 3,
				stage1Minute: existingSetting.stage1Minute ?? null,
				stage1Fee: existingSetting.stage1Fee ?? null,
				stage2Minute: existingSetting.stage2Minute ?? null,
				stage2Fee: existingSetting.stage2Fee ?? null,
				stage3Minute: existingSetting.stage3Minute ?? null,
				stage3Fee: existingSetting.stage3Fee ?? null,
				sweepCodeStatus: existingSetting.sweepCodeStatus === 1,
				sweepCodeTip: existingSetting.sweepCodeTip || '',
				prechargeStatus: existingSetting.prechargeStatus === 1,
				precharge: existingSetting.precharge ?? null,
				enableLimit: existingSetting.enableLimit === 1,
				limitAmount: existingSetting.limitAmount ?? null,
				allowDispatch: existingSetting.allowDispatch === 1,
				dispatchingFee: existingSetting.dispatchingFee ?? null,
				operationTime: existingSetting.operatingStartTime && existingSetting.operatingEndTime 
					? [existingSetting.operatingStartTime.substring(0, 5), existingSetting.operatingEndTime.substring(0, 5)] 
					: ['06:00', '23:00'],
				enableFenceReturn: existingSetting.enableFenceReturn === 1,
				enableOutAreaAlarm: existingSetting.enableOutAreaAlarm === 1,
				enableBluetoothUnlock: existingSetting.enableBluetoothUnlock === 1
			};
			this.configDialogTitle = '编辑车辆类型配置';
			this.configDialogVisible = true;
		},
		saveDeviceTypeConfig() {
			this.$refs.configFormRef.validate((valid) => {
				if (valid) {
					const saveData = {
						distributorId: this.currentDistributorId,
						deviceTypeCode: this.configForm.deviceTypeCode,
						bicycleType: this.configForm.bicycleType,
						chargingType: this.configForm.chargingType,
						stage1Minute: this.configForm.stage1Minute,
						stage1Fee: this.configForm.stage1Fee,
						stage2Minute: this.configForm.stage2Minute,
						stage2Fee: this.configForm.stage2Fee,
						stage3Minute: this.configForm.stage3Minute,
						stage3Fee: this.configForm.stage3Fee,
						sweepCodeStatus: this.configForm.sweepCodeStatus ? 1 : 0,
						sweepCodeTip: this.configForm.sweepCodeTip,
						prechargeStatus: this.configForm.prechargeStatus ? 1 : 0,
						precharge: this.configForm.precharge,
						enableLimit: this.configForm.enableLimit ? 1 : 0,
						limitAmount: this.configForm.limitAmount,
						allowDispatch: this.configForm.allowDispatch ? 1 : 0,
						dispatchingFee: this.configForm.dispatchingFee,
						operatingStartTime: this.configForm.operationTime && this.configForm.operationTime.length === 2 ? this.configForm.operationTime[0] + ':00' : '',
						operatingEndTime: this.configForm.operationTime && this.configForm.operationTime.length === 2 ? this.configForm.operationTime[1] + ':00' : '',
						enableFenceReturn: this.configForm.enableFenceReturn ? 1 : 0,
						enableOutAreaAlarm: this.configForm.enableOutAreaAlarm ? 1 : 0,
						enableBluetoothUnlock: this.configForm.enableBluetoothUnlock ? 1 : 0
					};
					
					this.$http.post('/distributor/setting/saveByDeviceType', saveData).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.$message.success('保存成功');
						this.configDialogVisible = false;
						this.distributorSettingInit(this.currentDistributorId);
					});
				}
			});
		},
		showQrCode(row) {
			this.qrCodeDistributorId = row.id;
			this.qrCodeDistributorName = row.name;
			this.qrCodeDialogVisible = true;
			
			this.$nextTick(() => {
				this.generateQrCode(row.id);
			});
		},
		clearQrCode() {
			const container = document.getElementById('qrcodeContainer');
			if (container) {
				container.innerHTML = '';
			}
		},
		generateQrCode(distributorId) {
			const container = document.getElementById('qrcodeContainer');
			if (!container) return;
			
			container.innerHTML = '';
			
			const qrUrl = `https://yunwei.ahzlyouxin.cn/?roleId=da11fa9868d544289feea88ff7c48654&distributorId=${distributorId}`;
			
			if (typeof QRCode !== 'undefined') {
				new QRCode(container, {
					text: qrUrl,
					width: 256,
					height: 256,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.L
				});
			} else {
				console.error('QRCode library not loaded');
				container.innerHTML = '<div style="width:256px;height:256px;border:1px solid #ddd;display:flex;align-items:center;justify-content:center;color:#999;">二维码加载失败</div>';
			}
		},
		showSetParentDialog(row) {
			this.setParentForm = {
				distributorId: row.id,
				currentName: row.name,
				currentLevel: row.level,
				parentId: row.parentId || ''
			};
			this.loadDistributorTree();
			this.setParentDialogVisible = true;
		},
		async loadDistributorTree() {
			try {
				const { data: res } = await this.$http.get('/distributor/manager/getTree');
				if (res.code === 200) {
					this.distributorTreeData = this.filterCurrentDistributor(res.data, this.setParentForm.distributorId);
				}
			} catch (error) {
				console.error('加载运营商树失败:', error);
			}
		},
		filterCurrentDistributor(tree, currentId) {
			return tree.filter(node => {
				if (node.id === currentId) {
					return false;
				}
				if (node.children && node.children.length > 0) {
					node.children = this.filterCurrentDistributor(node.children, currentId);
				}
				return true;
			});
		},
		async submitSetParent() {
			this.setParentLoading = true;
			try {
				const { data: res } = await this.$http.post('/distributor/manager/setParent', {
					distributorId: this.setParentForm.distributorId,
					parentId: this.setParentForm.parentId || null
				});
				if (res.code === 200) {
					this.$message.success('设置成功');
					this.setParentDialogVisible = false;
					this.getdistributorList();
				} else {
					this.$message.error(res.msg || '设置失败');
				}
			} catch (error) {
				this.$message.error('请求失败');
			} finally {
				this.setParentLoading = false;
			}
		},
		showApplymentDialog() {
			this.applymentStep = 0;
			this.applymentForm = {
				merchant_shortname: '',
				contact_type: 'LEGAL',
				contact_name: '',
				mobile_phone: '',
				contact_email: '',
				subject_type: '',
				license_number: '',
				merchant_name: '',
				legal_person: '',
				license_copy: '',
				sales_scenes_type: ['SALES_SCENES_MINI_PROGRAM']
			};
			this.applymentResult = {
				applyment_state: '',
				applyment_state_msg: '',
				qrcode_data: '',
				business_code: '',
				merchant_shortname: '',
				message: ''
			};
			this.applymentDialogVisible = true;
		},
		closeApplymentDialog() {
			this.applymentDialogVisible = false;
			this.applymentStep = 0;
		},
		async submitApplyment() {
			this.$refs.applymentFormRef.validate(async (valid) => {
				if (!valid) return;

				this.applymentStep = 1;
				this.applymentSubmitting = true;

				try {
					const businessCode = 'APPLY_' + Date.now();

					const contactInfo = {
						contact_type: this.applymentForm.contact_type,
						contact_name: this.applymentForm.contact_name,
						mobile_phone: this.applymentForm.mobile_phone,
						contact_email: this.applymentForm.contact_email
					};

					const subjectInfo = {
						subject_type: this.applymentForm.subject_type
					};

					if (this.applymentForm.subject_type !== 'SUBJECT_TYPE_MICRO') {
						subjectInfo.business_license_info = {
							license_copy: this.applymentForm.license_copy,
							license_number: this.applymentForm.license_number,
							merchant_name: this.applymentForm.merchant_name,
							legal_person: this.applymentForm.legal_person
						};
					}

					const requestData = {
						business_code: businessCode,
						contact_info: contactInfo,
						subject_info: subjectInfo,
						business_info: {
							merchant_shortname: this.applymentForm.merchant_shortname,
							sales_info: {
								sales_scenes_type: this.applymentForm.sales_scenes_type
							}
						}
					};

					const { data: submitRes } = await this.$http.post('/sub/merchant/applyment/submit', requestData);
					if (submitRes.code !== 200) {
						this.$message.error(submitRes.msg || '提交申请失败');
						this.applymentStep = 0;
						return;
					}

					this.applymentResult = {
						applyment_state: 'APPLYMENT_STATE_AUDITING',
						applyment_state_msg: '审核中',
						qrcode_data: '',
						business_code: businessCode,
						merchant_shortname: this.applymentForm.merchant_shortname,
						message: '申请已提交，等待微信审核。审核通过后将生成确认二维码，请定期刷新状态查看进度。'
					};

					if (submitRes.data && submitRes.data.applyment_id) {
						this.applymentResult.applyment_id = submitRes.data.applyment_id;
					}

					this.applymentStep = 2;
					this.$message.success('申请已提交成功，请等待审核');
				} catch (error) {
					this.$message.error('提交申请失败: ' + (error.message || '未知错误'));
					this.applymentStep = 0;
				} finally {
					this.applymentSubmitting = false;
				}
			});
		},
		async queryApplymentStatus(businessCode) {
			try {
				const { data: queryRes } = await this.$http.post('/sub/merchant/applyment/queryApplymentStatus', {
					businessCode: businessCode
				});

				if (queryRes.code !== 200) {
					this.$message.error(queryRes.msg || '查询申请状态失败');
					return;
				}

				this.applymentResult = {
					...this.applymentResult,
					...queryRes.data
				};

				if (this.applymentResult.applyment_state === 'APPLYMENT_STATE_PASSED') {
					this.$message.success('开户意愿确认已完成！');
				} else if (this.applymentResult.applyment_state === 'APPLYMENT_STATE_REJECTED') {
					this.$message.warning('申请已被驳回，请查看驳回原因');
				} else if (this.applymentResult.qrcode_data) {
					this.$message.success('确认二维码已生成，请扫码确认');
				} else {
					this.$message.info('审核中，暂未生成确认二维码，请稍后再试');
				}
			} catch (error) {
				this.$message.error('查询申请状态失败: ' + (error.message || '未知错误'));
			}
		},
		async refreshApplymentStatus() {
			this.refreshLoading = true;
			try {
				await this.queryApplymentStatus(this.applymentResult.business_code);
				this.$message.success('状态已刷新');
			} catch (error) {
				this.$message.error('刷新状态失败');
			} finally {
				this.refreshLoading = false;
			}
		},
		showSubMerchantQrCode() {
			this.showApplymentDialog();
		},
		handleLicenseUploadSuccess(response) {
			if (response.code === 200 && response.data) {
				this.applymentForm.license_copy = response.data.media_id;
				this.$message.success('营业执照上传成功');
			} else {
				this.$message.error('上传失败: ' + (response.msg || '未知错误'));
			}
		},
		handleLicenseUploadError() {
			this.$message.error('上传失败，请重试');
		}
	}
}
</script>

<style></style>
